import api from '../../../api'
import Vue from 'vue'
import uniqid from 'uniqid'
import filters from '../../../utils/filters'

const isBusService = item => item.ibeData.anfCode === 'BU'
const isRailService = item => item.ibeData.anfCode === 'BA'
const isExcursionService = item => item.ibeData.anfCode === 'LA'
const isBeverageService = item => item.ibeData.code === 'GETR' || item.ibeData.code.startsWith('GETR_')
const isOtherTravelService = item => !isBusService(item) && !isRailService(item) && !isExcursionService(item) && !isBeverageService(item)
const isVisible = item => item.ibeData.show === 1

const state = {
  ibeResponse: { responseType: '' },
  operatorInfo: [],
  appControl: {},
  object: {},
  consultant: {},
  agency: {
    id: 0
  },
  occupancy: {},
  availableTransports: {},
  availablePrograms: {},
  availableFromDates: [],
  availableToDates: [],
  availablePackages: [],
  availableUnits: [],
  availableServices: [],
  availableTravelServices: [],
  availableTrainServices: [],
  availableBusServices: [],
  availableInsurances: { data: [] },
  availablePayments: [],
  availableWidth: 0,
  trainStations: [],
  innerHeight: 0,
  mediaquery: 0,
  infopages: [],
  images: [],
  countries: [],
  data: {
    transport: {
      idArrivalTransport: '',
      idReturnTransport: ''
    },
    mandatoryService: {
      idVisumService: ''
    },
    program: {
      preProgram: {
        id: 0,
        count: 0
      },
      postProgram: {
        id: 0,
        count: 0
      },
      stopover: {
        id: 0,
        count: 0
      }
    },
    trainService: [],
    travelService: [],
    idBusService: 0,
    idInsurance: -1,
    trainStation: { value: '', code: '' },
    payment: {
      type: '',
      state: '',
      token: '',
      msg: {}
    },
    unitsTravelers: [{
      travelers: {
        adults: [{
          id: uniqid(),
          salutation: '',
          firstname: '',
          lastname: '',
          birthdate: '',
          placeOfBirth: '',
          nationality: '',
          passportType: '',
          passportNumber: '',
          passportDate: '',
          passportDateOfExpiry: '',
          passportIssuingCity: '',
          age: '',
          price: '',
          services: []
        }, {
          id: uniqid(),
          salutation: '',
          firstname: '',
          lastname: '',
          placeOfBirth: '',
          nationality: '',
          passportType: '',
          passportNumber: '',
          passportDate: '',
          passportDateOfExpiry: '',
          passportIssuingCity: '',
          birthdate: '',
          age: '',
          price: '',
          services: []
        }],
        children: [],
        infants: []
      },
      unit: {
        id: 0,
        count: 0,
        price: 0
      }
    }],
    customer: {
      salutation: '',
      title: '',
      firstname: '',
      lastname: '',
      agencyName: '',
      street: '',
      streetNr: '',
      zipCode: '',
      city: '',
      residence: '',
      phone: '',
      mobile: '',
      email: '',
      fax: '',
      remarks: ''
    }
  },
  ptdFormAccepted: false,
  ptdPrecontractualInfoAccepted: false,
  gtcAccepted: false,
  iddAccepted: false,
  dataPrivacyAccepted: false,
  initDataLoaded: false,
  fetchingData: false,
  nextStep: 1,
  bookFinished: false,
  showBookActionLoader: false,
  requestBooking: false,
  dropdownAppeared: false,
  updateIndicator: 0
}

const getters = {
  agency: state => {
    return state.agency
  },
  operatorInfo: state => {
    return state.operatorInfo
  },
  updateIndicator: state => {
    return state.updateIndicator
  },
  fetchingData: state => {
    return state.fetchingData
  },
  dropdownAppeared: state => {
    return state.dropdownAppeared
  },
  gtcAccepted: state => {
    return state.gtcAccepted
  },
  ptdFormAccepted: state => {
    return state.ptdFormAccepted
  },
  ptdPrecontractualInfoAccepted: state => {
    return state.ptdPrecontractualInfoAccepted
  },
  iddAccepted: state => {
    return state.iddAccepted
  },
  dataPrivacyAccepted: state => {
    return state.dataPrivacyAccepted
  },
  requestBooking: state => {
    return state.requestBooking
  },
  showBookActionLoader: state => {
    return state.showBookActionLoader
  },
  bookFinished: state => {
    return state.bookFinished
  },
  ibeResponse: state => {
    return state.ibeResponse
  },
  appControl: state => {
    return state.appControl
  },
  nextStep: state => {
    return state.nextStep
  },
  object: state => {
    return state.object
  },
  consultant: state => {
    return state.consultant
  },
  occupancy: state => {
    return state.occupancy
  },
  trainStations: state => {
    return state.trainStations
  },
  availableUnits: state => {
    return state.availableUnits
  },
  availableTransports: state => {
    return state.availableTransports
  },
  availablePrograms: state => {
    return state.availablePrograms
  },
  availableServices: state => {
    return state.availableServices
  },
  availableTravelServices: state => {
    return state.availableTravelServices
  },
  availableTrainServices: state => {
    return state.availableTrainServices
  },
  availableBusServices: state => {
    return state.availableBusServices
  },
  availableInsurances: state => {
    return state.availableInsurances
  },
  availableFromDates: state => {
    return state.availableFromDates
  },
  availableToDates: state => {
    return state.availableToDates
  },
  availableWidth: state => {
    return state.availableWidth
  },
  innerHeight: state => {
    return state.innerHeight
  },
  images: state => {
    return state.images
  },
  countries: state => {
    return state.countries
  },
  mediaquery: state => {
    return state.mediaquery
  },
  infopages: state => {
    return state.infopages
  },
  idInsurance: state => {
    return state.data.idInsurance
  },
  trainService: state => {
    return state.data.trainService
  },
  travelService: state => {
    return state.data.travelService
  },
  idBusService: state => {
    return state.data.idBusService
  },
  trainStation: state => {
    return state.data.trainStation
  },
  insurance: state => {
    if (state.data.idInsurance > 0) {
      return Vue.prototype._find(state.availableInsurances.data, { 'id': state.data.idInsurance })
    } else {
      return { 'id': 0 }
    }
  },
  payment: state => {
    return state.data.payment
  },
  services: state => {
    let travelers = []
    Vue.prototype._each(getters.totalTravelers(state), value => {
      travelers = Vue.prototype._concat(travelers, value)
    })

    return Vue.prototype._groupBy(Vue.prototype._flatMap(travelers, value => {
      return value.services
    }), service => {
      return service
    })
  },
  transport: state => {
    return state.data.transport
  },
  arrivalTransports: state => {
    return Vue.prototype._filter(state.availableTransports.arrival, value => {
      return value.ibeData.idPackage === state.object.ibeData.idPackage
    })
  },
  arrivalTransport: state => {
    if (Vue.prototype._find(state.availableTransports.arrival, { 'id': state.data.transport.idArrivalTransport })) {
      return Vue.prototype._find(state.availableTransports.arrival, { 'id': state.data.transport.idArrivalTransport })
    } else {
      return {}
    }
  },
  arrivalData: state => {
    let aArrivalData = []

    if (Object.keys(getters.arrivalTransport(state)).length) {
      aArrivalData.push(getters.arrivalTransport(state))
      if (getters.arrivalTransport(state).idMaster !== 0) {
        aArrivalData.push(Vue.prototype._find(state.availableTransports.arrival, { 'idService': getters.arrivalTransport(state).idMaster }))
      }
    }

    return aArrivalData
  },
  returnTransports: state => {
    return Vue.prototype._filter(Vue.prototype._filter(state.availableTransports.return, value => {
      return value.ibeData.idPackage === state.object.ibeData.idPackage
    }), service => {
      if (Object.keys(getters.arrivalTransport(state)).length) {
        let obj = getters.arrivalTransport(state)
        let type = obj.ibeData.type
        return type === 'SELF' || type === 'REQ' ? true : obj.combination.activated === 1 ? obj.combination.service === service.ibeData.code : true
      } else {
        return true
      }
    })
  },
  returnTransport: state => {
    if (Vue.prototype._find(state.availableTransports.return, { 'id': state.data.transport.idReturnTransport })) {
      return Vue.prototype._find(state.availableTransports.return, { 'id': state.data.transport.idReturnTransport })
    } else {
      return {}
    }
  },
  returnData: state => {
    let aReturnData = []

    if (Object.keys(getters.returnTransport(state)).length) {
      aReturnData.push(getters.returnTransport(state))
      if (getters.returnTransport(state).idMaster !== 0) {
        aReturnData.push(Vue.prototype._find(state.availableTransports.return, { 'idService': getters.returnTransport(state).idMaster }))
      }
    }

    return aReturnData
  },
  program: state => {
    return state.data.program
  },
  preProgram: state => {
    if (getters.program(state).preProgram.id !== 0) {
      return Vue.prototype._merge(getters.program(state).preProgram, Vue.prototype._find(state.availablePrograms.prePrograms, { 'id': getters.program(state).preProgram.id }))
    } else {
      return {}
    }
  },
  postProgram: state => {
    if (getters.program(state).postProgram.id !== 0) {
      return Vue.prototype._merge(getters.program(state).postProgram, Vue.prototype._find(state.availablePrograms.postPrograms, { 'id': getters.program(state).postProgram.id }))
    } else {
      return {}
    }
  },
  stopover: state => {
    if (getters.program(state).stopover.id !== 0) {
      return Vue.prototype._merge(getters.program(state).stopover, Vue.prototype._find(state.availablePrograms.stopovers, { 'id': getters.program(state).stopover.id }))
    } else {
      return {}
    }
  },
  mandatoryService: state => {
    return state.data.mandatoryService
  },
  mandatoryServices: state => {
    return Vue.prototype._filter(state.availableTravelServices, value => {
      return value.ibeData.idPackage === state.object.ibeData.idPackage && value.ibeData.group === 'Visum'
    })
  },
  travelServices: state => {
    return Vue.prototype._filter(state.availableTravelServices, value => {
      return value.ibeData.idPackage === state.object.ibeData.idPackage
    })
  },
  travelServicesBook: state => {
    return Vue.prototype._union(
      Vue.prototype._filter(getters.travelServices(state), value => {
        return value.ibeData.show === 0
      }),
      Vue.prototype._filter(getters.travelServices(state), value => {
        return Vue.prototype._indexOf(getters.travelService(state), value.id) >= 0
      }),
      Vue.prototype._filter(getters.mandatoryServices(state), value => {
        return value.id === getters.mandatoryService(state).idVisumService
      })
    )
  },
  busServices: state => {
    return Vue.prototype._filter(getters.travelServices(state), item => isBusService(item) && isVisible(item))
  },
  railServices: state => {
    return Vue.prototype._filter(getters.travelServices(state), item => isRailService(item) && isVisible(item))
  },
  excursionServices: state => {
    return Vue.prototype._filter(getters.travelServices(state), item => isExcursionService(item) && isVisible(item))
  },
  beverageServices: state => {
    return Vue.prototype._filter(getters.travelServices(state), item => isBeverageService(item) && isVisible(item))
  },
  otherTravelServices: state => {
    return Vue.prototype._filter(getters.travelServices(state), item => isOtherTravelService(item) && isVisible(item))
  },
  busServicesBook: state => {
    return Vue.prototype._filter(getters.travelServicesBook(state), isBusService)
  },
  railServicesBook: state => {
    return Vue.prototype._filter(getters.travelServicesBook(state), isRailService)
  },
  excursionServicesBook: state => {
    return Vue.prototype._filter(getters.travelServicesBook(state), isExcursionService)
  },
  beverageServicesBook: state => {
    return Vue.prototype._filter(getters.travelServicesBook(state), isBeverageService)
  },
  otherTravelServicesBook: state => {
    return Vue.prototype._filter(getters.travelServicesBook(state), isOtherTravelService)
  },
  trainServices: state => {
    return Vue.prototype._filter(state.availableTrainServices, value => {
      return value.ibeData.idPackage === state.object.ibeData.idPackage
    })
  },
  customer: state => {
    return state.data.customer
  },
  totalCountAdults: state => {
    return Vue.prototype._sumBy(state.data.unitsTravelers, obj => obj.travelers.adults.length)
  },
  totalCountChildren: state => {
    return Vue.prototype._sumBy(state.data.unitsTravelers, obj => obj.travelers.children.length)
  },
  totalCountInfants: state => {
    return Vue.prototype._sumBy(state.data.unitsTravelers, obj => obj.travelers.infants.length)
  },
  totalCountTravelers: state => {
    return getters.totalCountAdults(state) + getters.totalCountChildren(state) + getters.totalCountInfants(state)
  },
  totalTravelers: state => {
    let obj = {}
    obj.adults = Vue.prototype._flatMap(state.data.unitsTravelers, value => {
      return Vue.prototype._union(value.travelers.adults)
    })
    obj.children = Vue.prototype._flatMap(state.data.unitsTravelers, value => {
      return Vue.prototype._union(value.travelers.children)
    })
    obj.infants = Vue.prototype._flatMap(state.data.unitsTravelers, value => {
      return Vue.prototype._union(value.travelers.infants)
    })
    return obj
  },
  unitsTravelers: state => {
    return state.data.unitsTravelers
  },
  selectedUnits: state => {
    return Vue.prototype._map(Vue.prototype._filter(Vue.prototype._map(state.data.unitsTravelers, value => value.unit), value => value.id !== 0), item => {
      return Vue.prototype._merge(Vue.prototype._cloneDeep(item), Vue.prototype._find(state.availableUnits, { 'id': item.id }))
    })
  },
  selectedUnitsGrouped: state => {
    return Vue.prototype._groupBy(getters.selectedUnits(state), unit => {
      return unit.id
    })
  },
  initDataLoaded: state => {
    return state.initDataLoaded
  }
}

const mutations = {
  SET_OPERATOR_INFO: (state, payload) => {
    if (
      !Vue.prototype._find(state.operatorInfo, item => {
        return item.idBookingCode === payload.idBookingCode
      })
    ) {
      state.operatorInfo.push(payload)
    }
  },
  TOGGLE: (state, payload) => {
    state[payload] = !state[payload]
  },
  SET_OBJECT: (state, payload) => {
    state.object = payload
  },
  SET_CONSULTANT: (state, payload) => {
    state.consultant = payload
  },
  SET_AGENCY: (state, payload) => {
    state.agency = payload
  },
  SET_OCCUPANCY: (state, payload) => {
    state.occupancy = payload
  },
  SET_AVAILABLE_PAYMENTS: (state, payload) => {
    state.availablePayments = payload
  },
  SET_AVAILABLE_PACKAGES: (state, payload) => {
    state.availablePackages = payload
  },
  SET_AVAILABLE_UNITS: (state, payload) => {
    state.availableUnits = payload
  },
  SET_AVAILABLE_TRANSPORTS: (state, payload) => {
    state.availableTransports = payload
  },
  SET_AVAILABLE_PROGRAMS: (state, payload) => {
    state.availablePrograms = payload
  },
  SET_AVAILABLE_SERVICES: (state, payload) => {
    state.availableServices = payload
  },
  SET_AVAILABLE_TRAVELSERVICES: (state, payload) => {
    // TS: wenn katCode === '?', dann katCode = '' setzen
    payload.forEach(item => {
      if (item.ibeData.katCode === '?') {
        item.ibeData.katCode = ''
      }
    })
    state.availableTravelServices = payload
  },
  SET_AVAILABLE_TRAINSERVICES: (state, payload) => {
    state.availableTrainServices = payload
  },
  SET_AVAILABLE_BUSSERVICES: (state, payload) => {
    state.availableBusServices = payload
  },
  SET_IMAGES: (state, payload) => {
    state.images = payload
  },
  SET_COUNTRIES: (state, payload) => {
    state.countries = payload
  },
  SET_AVAILABLE_INSURANCES: (state, payload) => {
    state.availableInsurances = payload
  },
  SET_AVAILABLE_FROMDATES: (state, payload) => {
    state.availableFromDates = payload
  },
  SET_TRAINSTATIONS: (state, payload) => {
    state.trainStations = payload
  },
  SET_AVAILABLE_WIDTH: (state, payload) => {
    state.availableWidth = payload
  },
  SET_INNER_HEIGHT: (state, payload) => {
    state.innerHeight = payload
  },
  SET_MEDIAQUERY: (state, payload) => {
    state.mediaquery = payload
  },
  UPDATE_AVAILABLE_TODATES: (state, payload) => {
    state.availableToDates = payload
  },
  CHANGE_DATE_FROM: (state, payload) => {
    state.data.object.ibeData.dateFrom = payload
  },
  CHANGE_DATE_TO: (state, payload) => {
    state.data.object.ibeData.dateTo = payload
  },
  CHANGE_HOTEL_DATE_FROM: (state, payload) => {
    state.data.object.ibeData.dateHotelFrom = payload
  },
  CHANGE_HOTEL_DATE_TO: (state, payload) => {
    state.data.object.ibeData.dateHotelTo = payload
  },
  ADD_INFOPAGE: (state, payload) => {
    state.infopages.push(payload)
  },
  ADD_UNITTRAVELERS: (state) => {
    let unitTravelers = {
      travelers: {
        adults: [{
          id: uniqid(),
          salutation: '',
          firstname: '',
          lastname: '',
          placeOfBirth: '',
          nationality: '',
          passportType: '',
          passportNumber: '',
          passportDate: '',
          passportDateOfExpiry: '',
          passportIssuingCity: '',
          birthdate: '',
          age: '',
          price: '',
          services: []
        }, {
          id: uniqid(),
          salutation: '',
          firstname: '',
          lastname: '',
          placeOfBirth: '',
          nationality: '',
          passportType: '',
          passportNumber: '',
          passportDate: '',
          passportDateOfExpiry: '',
          passportIssuingCity: '',
          birthdate: '',
          age: '',
          price: '',
          services: []
        }],
        children: [],
        infants: []
      },
      unit: {
        id: 0,
        count: 0,
        price: 0
      }
    }
    state.data.unitsTravelers.push(unitTravelers)
  },
  DELETE_UNITTRAVELERS: (state, payload) => {
    state.data.unitsTravelers.splice(payload, 1)
  },
  CHANGE_COUNT_TRAVELERS: (state, payload) => {
    let arr = state.data.unitsTravelers[payload.index].travelers[payload.type]
    let count = payload.value

    if (count > arr.length) {
      for (let i = arr.length; i < count; i++) {
        let obj = {
          id: uniqid(),
          salutation: '',
          firstname: '',
          lastname: '',
          placeOfBirth: '',
          nationality: '',
          passportType: '',
          passportNumber: '',
          passportDate: '',
          passportDateOfExpiry: '',
          passportIssuingCity: '',
          birthdate: '',
          age: '',
          price: '',
          services: []
        }
        arr.push(obj)
      }
    } else {
      for (let i = arr.length; i > count; i--) {
        arr.pop()
      }
    }
  },
  SET_TRAVELER_PROPERTY: (state, payload) => {
    if (payload.prop === 'birthdate') {
      let age = ''
      let date = filters.parseLocalDate(getters.object(state).ibeData.dateFrom)

      if (state.appControl.matchAgeTravelBegin) {
        age = new Date(date - payload.value).getUTCFullYear() - 1970
      } else {
        date = filters.parseLocalDate(getters.object(state).ibeData.dateTo)
        age = new Date(date - payload.value).getUTCFullYear() - 1970
      }
      state.data.unitsTravelers[payload.index].travelers[payload.type][payload.number]['age'] = age
      state.data.unitsTravelers[payload.index].travelers[payload.type][payload.number]['birthdate'] = payload.value.toDateString()
    } else {
      state.data.unitsTravelers[payload.index].travelers[payload.type][payload.number][payload.prop] = payload.value
    }
  },
  CHANGE_UNIT: (state, payload) => {
    state.data.unitsTravelers[payload.index].unit = payload.unit
  },
  CHANGE_PAYMENT_TYPE: (state, payload) => {
    state.data.payment.type = payload
  },
  CHANGE_PAYMENT_STATE: (state, payload) => {
    state.data.payment.state = payload
  },
  CHANGE_PAYMENT_TOKEN: (state, payload) => {
    state.data.payment.token = payload
  },
  CHANGE_PAYMENT_MESSAGE: (state, payload) => {
    state.data.payment.msg = payload
  },
  CHANGE_PREPROGRAM: (state, payload) => {
    state.data.program['preProgram'] = payload
  },
  CHANGE_POSTPROGRAM: (state, payload) => {
    state.data.program['postProgram'] = payload
  },
  CHANGE_STOPOVER: (state, payload) => {
    state.data.program['stopover'] = payload
  },
  CHANGE_INSURANCE: (state, payload) => {
    state.data.idInsurance = payload
  },
  ADD_TRAINSERVICE: (state, payload) => {
    state.data.trainService.push(payload)
  },
  REMOVE_TRAINSERVICE: (state, payload) => {
    state.data.trainService.splice(Vue.prototype._indexOf(state.data.trainService, payload), 1)
  },
  RESET_TRAINSERVICE: (state, payload) => {
    state.data.trainService = payload
  },
  SET_TRAVELSERVICE: (state, payload) => {
    state.data.travelService = payload
  },
  CHANGE_TRAINSTATION: (state, payload) => {
    state.data.trainStation = payload
  },
  CHANGE_BUSSERVICE: (state, payload) => {
    state.data.idBusService = payload
  },
  CHANGE_ARRIVAL_TRANSPORT: (state, payload) => {
    state.data.transport.idArrivalTransport = payload
  },
  CHANGE_RETURN_TRANSPORT: (state, payload) => {
    state.data.transport.idReturnTransport = payload
  },
  SET_MANDATORY_SERVICE: (state, payload) => {
    state.data.mandatoryService.idVisumService = payload
  },
  UPDATE_TRAVELSERVICE: (state, payload) => {
    let obj = Vue.prototype._find(getters.travelServices(state), item => {
      return item.ibeData.idParent === payload.id
    })
    if (obj) {
      obj.ibeData.show = payload.show
    }
  },
  SET_CUSTOMER: (state, payload) => {
    state.data.customer = payload
  },
  ADD_SERVICE_TO_TRAVELER: (state, payload) => {
    payload.obj.services.push(payload.idService)
  },
  REMOVE_SERVICE_FROM_TRAVELER: (state, payload) => {
    payload.obj.services.splice(Vue.prototype._indexOf(payload.obj.services, payload.idService), 1)
    state.availableServices[payload.index].ibeData.price = 0
  },
  SET_INITDATA_LOADED: (state, payload) => {
    state.initDataLoaded = payload
  },
  SET_FETCHING_DATA: (state, payload) => {
    state.fetchingData = payload
  },
  SET_UPDATE_INDICATOR: (state) => {
    state.updateIndicator++
  },
  SET_IBERESPONSE: (state, payload) => {
    let unit = {}
    let transportService = {}
    let travelService = {}
    let trainService = {}
    let insurance = {}
    state.ibeResponse = payload.IBEResponse
    state.data.customer = payload.customer

    if (payload.IBEResponse.bookingType === 'REQUEST') {
      state.requestBooking = true
    } else {
      state.requestBooking = false
    }
    if (payload.object) {
      state.object.ibeData.price = payload.object.price
    }
    if (payload.transport) {
      for (let a = 0; a < payload.transport.arrival.length; a++) {
        transportService = Vue.prototype._find(state.availableTransports.arrival, { 'id': payload.transport.arrival[a].id })
        transportService.ibeData = payload.transport.arrival[a].ibeData
      }
      for (let a = 0; a < payload.transport.return.length; a++) {
        transportService = Vue.prototype._find(state.availableTransports.return, { 'id': payload.transport.return[a].id })
        transportService.ibeData = payload.transport.return[a].ibeData
      }
    }
    if (payload.units) {
      for (let i = 0; i < payload.units.length; i++) {
        unit = Vue.prototype._find(state.availableUnits, { 'id': payload.units[i].unit.id })
        unit.ibeData = payload.units[i].unit.ibeData
        state.data.unitsTravelers[i].unit.price = payload.units[i].unit.price
      }
    }
    if (Object.keys(payload.program.preProgram).length) {
      state.data.program.preProgram.ibeData.price = payload.program.preProgram.price
    }
    if (Object.keys(payload.program.postProgram).length) {
      state.data.program.postProgram.ibeData.price = payload.program.postProgram.price
    }
    if (payload.travelServices) {
      for (let i = 0; i < payload.travelServices.length; i++) {
        travelService = Vue.prototype._find(state.availableTravelServices, item => {
          return item.ibeData.idBookingCode === payload.travelServices[i].idBookingCode
            && item.ibeData.idPackage === payload.travelServices[i].idPackage
            && item.ibeData.katCode === payload.travelServices[i].katCode
        })
        travelService.ibeData.price = payload.travelServices[i].price
      }
    }
    if (payload.trainServices) {
      for (let i = 0; i < payload.trainServices.length; i++) {
        trainService = Vue.prototype._find(state.availableTrainServices, item => {
          return item.ibeData.idBookingCode === payload.trainServices[i].idBookingCode && item.ibeData.katCode === payload.trainServices[i].katCode && item.ibeData.idPackage === payload.trainServices[i].idPackage
        })
        trainService.ibeData.price = payload.trainServices[i].price
      }
    }
    if (payload.services) {
      for (let s = 0; s < payload.services.length; s++) {
        state.availableServices[s].ibeData = payload.services[s]
      }
    }
    if (payload.insurance && payload.insurance.id > 0) {
      insurance = Vue.prototype._find(state.availableInsurances.data, { 'id': payload.insurance.id })
      insurance.ibeData = payload.insurance.ibeData
    }
  },
  SET_SHOWBOOKACTIONLOADER: (state, payload) => {
    state.showBookActionLoader = payload
  },
  SET_APPCONTROL: (state, payload) => {
    state.appControl = payload
  },
  SET_NEXTSTEP: (state, payload) => {
    state.nextStep = payload
  },
  SET_BOOKFINISHED: (state, payload) => {
    state.bookFinished = payload
  },
  SET_GTC_ACCEPTED: (state, payload) => {
    state.gtcAccepted = payload
  },
  SET_PTD_FORM_ACCEPTED: (state, payload) => {
    state.ptdFormAccepted = payload
  },
  SET_PTD_PRECONTRACTUAL_INFO_ACCEPTED: (state, payload) => {
    state.ptdPrecontractualInfoAccepted = payload
  },
  SET_IDD_ACCEPTED: (state, payload) => {
    state.iddAccepted = payload
  },
  SET_DATAPRIVACY_ACCEPTED: (state, payload) => {
    state.dataPrivacyAccepted = payload
  }
}

const actions = {
  setOperatorInfo: ({ commit }, payload) => {
    commit('SET_OPERATOR_INFO', payload)
  },
  toggle: ({ commit }, payload) => {
    commit('TOGGLE', payload)
  },
  setGTCAccepted: ({ commit }, payload) => {
    commit('SET_GTC_ACCEPTED', payload)
  },
  setPTDFormAccepted: ({ commit }, payload) => {
    commit('SET_PTD_FORM_ACCEPTED', payload)
  },
  setPTDPrecontractualInfoAccepted: ({ commit }, payload) => {
    commit('SET_PTD_PRECONTRACTUAL_INFO_ACCEPTED', payload)
  },
  setIDDAccepted: ({ commit }, payload) => {
    commit('SET_IDD_ACCEPTED', payload)
  },
  setDataPrivacyAccepted: ({ commit }, payload) => {
    commit('SET_DATAPRIVACY_ACCEPTED', payload)
  },
  setBookFinished: ({ commit }, payload) => {
    commit('SET_BOOKFINISHED', payload)
  },
  setAppControl: ({ commit }, payload) => {
    commit('SET_APPCONTROL', payload)
  },
  setNextStep: ({ commit }, payload) => {
    commit('SET_NEXTSTEP', payload)
  },
  setAvailableUnits: ({ commit }, payload) => {
    commit('SET_AVAILABLE_UNITS', payload)
  },
  setAvailableServices: ({ commit }, payload) => {
    commit('SET_AVAILABLE_SERVICES', payload)
  },
  setAvailableFromDates: ({ commit }, payload) => {
    commit('SET_AVAILABLE_FROMDATES', payload)
  },
  updateAvailableToDates: ({ commit }, payload) => {
    commit('UPDATE_AVAILABLE_TODATES', payload)
  },
  changeFromDate: ({ commit }, payload) => {
    commit('CHANGE_DATE_FROM', payload)
  },
  changeToDate: ({ commit }, payload) => {
    commit('CHANGE_DATE_TO', payload)
  },
  changeHotelFromDate: ({ commit }, payload) => {
    commit('CHANGE_HOTEL_DATE_FROM', payload)
  },
  changeHotelToDate: ({ commit }, payload) => {
    commit('CHANGE_HOTEL_DATE_TO', payload)
  },
  changeArrivalTransport: ({ commit }, payload) => {
    let idBookingCode = 0
    commit('CHANGE_RETURN_TRANSPORT', '')
    if (Object.keys(getters.arrivalTransport(state)).length) {
      idBookingCode = getters.arrivalTransport(state).ibeData.idBookingCode
      commit('UPDATE_TRAVELSERVICE', { id: idBookingCode, show: 0 })
    }
    return new Promise((resolve, reject) => {
      commit('CHANGE_ARRIVAL_TRANSPORT', payload)
      commit('SET_UPDATE_INDICATOR')
      if (Object.keys(getters.arrivalTransport(state)).length) {
        idBookingCode = getters.arrivalTransport(state).ibeData.idBookingCode
        commit('UPDATE_TRAVELSERVICE', { id: idBookingCode, show: 1 })
      }
      resolve()
    })
  },
  changeReturnTransport: ({ commit }, payload) => {
    let idBookingCode = 0

    if (Object.keys(getters.returnTransport(state)).length) {
      idBookingCode = getters.returnTransport(state).ibeData.idBookingCode
      commit('UPDATE_TRAVELSERVICE', { id: idBookingCode, show: 0 })
    }
    return new Promise((resolve, reject) => {
      commit('CHANGE_RETURN_TRANSPORT', payload)
      commit('SET_UPDATE_INDICATOR')
      if (Object.keys(getters.returnTransport(state)).length) {
        idBookingCode = getters.returnTransport(state).ibeData.idBookingCode
        commit('UPDATE_TRAVELSERVICE', { id: idBookingCode, show: 1 })
      }
      resolve()
    })
  },
  setMandatoryService: ({ commit }, payload) => {
    commit('SET_MANDATORY_SERVICE', payload)
    commit('SET_UPDATE_INDICATOR')
  },
  addUnitTravelers: ({ commit }) => {
    commit('ADD_UNITTRAVELERS')
  },
  deleteUnitTravelers: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('DELETE_UNITTRAVELERS', payload)
      resolve()
    })
  },
  changeCountTravelers: ({ commit }, payload) => {
    commit('CHANGE_COUNT_TRAVELERS', payload)
  },
  setTravelerProperty: ({ commit }, payload) => {
    commit('SET_TRAVELER_PROPERTY', payload)
  },
  changeUnit: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_UNIT', payload)
      resolve()
    })
  },
  changePaymentType: ({ commit }, payload) => {
    commit('CHANGE_PAYMENT_TYPE', payload)
  },
  changePaymentState: ({ commit }, payload) => {
    commit('CHANGE_PAYMENT_STATE', payload)
  },
  changePaymentToken: ({ commit }, payload) => {
    commit('CHANGE_PAYMENT_TOKEN', payload)
  },
  changePaymentMessage: ({ commit }, payload) => {
    commit('CHANGE_PAYMENT_MESSAGE', payload)
  },
  changePreProgram: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_PREPROGRAM', payload)
      resolve()
    })
  },
  changePostProgram: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_POSTPROGRAM', payload)
      resolve()
    })
  },
  changeStopover: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_STOPOVER', payload)
      commit('SET_UPDATE_INDICATOR')
      resolve()
    })
  },
  changeInsurance: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_INSURANCE', payload)
      resolve()
    })
  },
  changeTrainStation: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_TRAINSTATION', payload)
      commit('SET_UPDATE_INDICATOR')
      resolve()
    })
  },
  addTrainService: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('ADD_TRAINSERVICE', payload)
      resolve()
    })
  },
  resetTrainService: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('RESET_TRAINSERVICE', payload)
      commit('SET_UPDATE_INDICATOR')
      resolve()
    })
  },
  setTravelService: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('SET_TRAVELSERVICE', payload)
      commit('SET_UPDATE_INDICATOR')
      resolve()
    })
  },
  changeBusService: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('CHANGE_BUSERVICE', payload)
      commit('SET_UPDATE_INDICATOR')
      resolve()
    })
  },
  setCustomer: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('SET_CUSTOMER', payload)
      resolve()
    })
  },
  setAvailableWidth: ({ commit }, payload) => {
    commit('SET_AVAILABLE_WIDTH', payload)
  },
  setInnerHeight: ({ commit }, payload) => {
    commit('SET_INNER_HEIGHT', payload)
  },
  setMediaquery: ({ commit }, payload) => {
    commit('SET_MEDIAQUERY', payload)
  },
  addServiceToTraveler: ({ commit }, payload) => {
    commit('ADD_SERVICE_TO_TRAVELER', payload)
  },
  removeServiceFromTraveler: ({ commit }, payload) => {
    commit('REMOVE_SERVICE_FROM_TRAVELER', payload)
  },
  setFetchingData: ({ commit }, payload) => {
    commit('SET_FETCHING_DATA', payload)
  },
  setUpdateIndicator: ({ commit }) => {
    commit('SET_UPDATE_INDICATOR')
  },
  updatePackage: ({ commit }) => {
    let objData = state.object
    let code = objData.ibeData.masterCode
    let newObjData = {}

    if (state.data.program.preProgram.id > 0) {
      code = code + 'VP'
    }
    if (state.data.program.postProgram.id > 0) {
      code = code + 'NP'
    }

    Vue.prototype._each(state.availablePackages, (value, index) => {
      if (value.ibeData.code === code) {
        newObjData = value
      }
    })
    commit('SET_OBJECT', newObjData)
  },
  doBookingAction: ({ commit }, payload) => {
    payload = payload || 'BOOKREQUEST'
    commit('SET_SHOWBOOKACTIONLOADER', true)
    let requestData = {
      IBEResponse: getters.ibeResponse(state),
      object: {
        ...state.object.ibeData,
        name: state.object.text.name,
        shipName: state.object.text.shipName
      },
      transport: {
        arrival: getters.arrivalData(state),
        return: getters.returnData(state)
      },
      program: {
        preProgram: getters.preProgram(state).ibeData ? { ...getters.preProgram(state).ibeData, count: getters.preProgram(state).count } : {},
        postProgram: getters.postProgram(state).ibeData ? { ...getters.postProgram(state).ibeData, count: getters.postProgram(state).count } : {},
        stopover: getters.stopover(state).ibeData ? { ...getters.stopover(state).ibeData, count: getters.stopover(state).count } : {}
      },
      units: Vue.prototype._map(Vue.prototype._filter(Vue.prototype._cloneDeep(state.data.unitsTravelers), value => {
        return value.unit.id !== 0
      }), item => {
        item.unit.ibeData = Vue.prototype._find(state.availableUnits, { 'id': item.unit.id }).ibeData
        return item
      }),
      travelServices: Vue.prototype._map(getters.travelServicesBook(state), item => { return item.ibeData }),
      trainServices: Vue.prototype._map(Vue.prototype._filter(Vue.prototype._cloneDeep(getters.trainServices(state)), value => {
        return Vue.prototype._indexOf(getters.trainService(state), value.id) >= 0
      }), item => {
        return item.ibeData
      }),
      trainStation: getters.trainStation(state).code,
      services: Vue.prototype._map(state.availableServices, 'ibeData'),
      insurance: getters.insurance(state),
      customer: getters.customer(state),
      agency: getters.agency(state),
      payment: getters.payment(state),
    }
    return api.doBookingAction({ actionType: payload, data: requestData, sessionId: window.initData.sessionId })
      .then(response => {
        return response.json()
      }, error => {
        console.log(error)
        requestData.IBEResponse = {}
        requestData.IBEResponse.responseType = 'ERROR'
        return requestData
      })
      .then(data => {
        commit('SET_IBERESPONSE', data)
        commit('SET_SHOWBOOKACTIONLOADER', false)
      })
  },
  getBookingData: ({ commit }) => {
    let requestData = {
      currency: window.initData.currency.toUpperCase(),
      language: window.initData.language.toUpperCase(),
      idMediaObject: window.initData.idObject,
      idMediaObjectTermin: window.initData.idTermin,
      idMediaObjectFromCategory: window.initData.idCategory,
      cabinNumber: window.initData.cabinNumber,
      agenturNr: window.initData.agenturNr,
    }
    api.getBookingData(requestData)
      .then(response => {
        return response.json()
      }, error => {
        console.log(error)
        requestData.IBEResponse = {}
        requestData.IBEResponse.responseType = 'FATAL'
        return requestData
      })
      .then(data => {
        if (data.IBEResponse) {
          commit('SET_IBERESPONSE', data)
        } else {
          commit('SET_OBJECT', data.objectData)
          commit('SET_AVAILABLE_PACKAGES', data.packages)
          //commit('SET_AVAILABLE_PAYMENTS', data.paymentData)
          commit('SET_AVAILABLE_UNITS', data.unitData)
          commit('SET_AVAILABLE_TRANSPORTS', data.transportData)
          commit('SET_AVAILABLE_PROGRAMS', data.programData)
          commit('SET_AVAILABLE_SERVICES', data.serviceData)
          commit('SET_AVAILABLE_TRAVELSERVICES', data.travelServiceData)
          commit('SET_AVAILABLE_TRAINSERVICES', data.trainServiceData)
          commit('SET_AVAILABLE_BUSSERVICES', data.busServiceData)
          commit('SET_IMAGES', data.images)
          commit('SET_COUNTRIES', data.countries)
          commit('SET_CONSULTANT', data.consultantData)
          commit('SET_OCCUPANCY', data.occupancyData)
          commit('SET_AGENCY', data.agencyData)
        }
      })
      .then(data => {
        commit('SET_INITDATA_LOADED', true)
      })
  },
  getTrainStations: ({ commit }) => {
    let requestData = {}
    return api.getTrainStations(JSON.stringify(requestData))
      .then(response => {
        return response.json()
      }, error => {
        console.log(error)
        return {}
      })
      .then(data => {
        commit('SET_TRAINSTATIONS', data)
      })
  },
  getInsuranceData: ({ commit }) => {
    let travelers = getters.totalTravelers(state)
    const travelServices = Vue.prototype._map(getters.travelServicesBook(state), item => { return item.ibeData })
    const getraenkePakete = travelServices.filter(item => item.code === 'GETR' || item.code.startsWith('GETR_'))
    const prices = Vue.prototype._map(getraenkePakete, item => { return item.price })
    const sum = prices.reduce((accumulator, currentValue) => {
      return accumulator + currentValue
    }, 0);

    let requestData = {
      object: JSON.parse(JSON.stringify(state.object)),
      countTravelers: Vue.prototype._union(travelers.adults, travelers.children).length
    }
    requestData.object.ibeData.price = requestData.object.ibeData.price - sum

    return api.getInsuranceData(JSON.stringify(requestData))
      .then(response => {
        return response.json()
      }, error => {
        console.log(error)
        return { data: [] }
      })
      .then(data => {
        commit('SET_AVAILABLE_INSURANCES', data)
      })
  },
  getPage: ({ commit }, payload) => {
    const pages = {
      'AGB': 'https://development-plantours-partner-de.pressmind.dev/reisebedingungen-agb/?no_header=1&no_footer=1'
    }

    let test = fetch('http://localhost:8080')
      .then(response => {
        return response.text();
      })
      .then(data => {
        return data
      })

    return test
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
